import { Box, Wrap, WrapItem } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { updateTemporaryContact } from '../api/Drafts';
import { useAuthenticateApiCall } from './hooks/useAuthenticateApiCall';
import useInlineForm from './hooks/useInlineForm';
import { InlineField } from './InlineInput';

type TempContactName = { name: string };
type TempContactNameKeys = keyof TempContactName;

const nameSchema = yup.object().shape<Record<TempContactNameKeys, any>>({
  name: yup.string().label('Temporary Name').required().max(50),
});

type TempContactEmail = { email: string };
type TempContactEmailKeys = keyof TempContactEmail;

const emailSchema = yup.object().shape<Record<TempContactEmailKeys, any>>({
  email: yup.string().label('Temporary Email').email().required().max(254),
});

const useTemporaryContactSubmission = (id: string) => {
  const endpoint = useAuthenticateApiCall(updateTemporaryContact);

  return {
    nameSubmission: (name: string) => endpoint(id, { name }).then(console.log),
    emailSubmission: (email: string) => endpoint(id, { email }).then(console.log),
  };
};

const InlineNameForm = ({ letterId, ...initialValues }: { letterId: string; name: string }) => {
  const { nameSubmission } = useTemporaryContactSubmission(letterId);
  const { formikProps } = useInlineForm(initialValues, (values) => nameSubmission(values.name));

  return (
    <Formik validationSchema={nameSchema} {...formikProps}>
      <Form>
        <Box mt={-1}>
          <InlineField placeholder="Pal" name="name" type="text" />
        </Box>
      </Form>
    </Formik>
  );
};

/** Currently unused. Might bring it back. */
export const InlineEmailForm = ({
  letterId,
  ...initialValues
}: {
  letterId: string;
  email: string;
}) => {
  const { emailSubmission } = useTemporaryContactSubmission(letterId);
  const { formikProps } = useInlineForm(initialValues, (values) => emailSubmission(values.email));

  return (
    <Formik validationSchema={emailSchema} {...formikProps}>
      <Form>
        <Box mt={-1}>
          <InlineField placeholder="mail@mail.com" name="email" type="text" />
        </Box>
      </Form>
    </Formik>
  );
};

type TempContactProps = {
  letterId: string;
  name: string;
  email?: string;
};

const TempContact = ({ letterId, name }: TempContactProps) => (
  <Wrap spacing={0}>
    <WrapItem>
      <InlineNameForm letterId={letterId} name={name} />
    </WrapItem>
  </Wrap>
);

export default TempContact;
